import type { Currency } from '../types';
import { GameState } from './GameState';
import { EventBus } from './EventBus';
import { OUTFITS_BY_ID } from '../data/outfits';
import { AudioManager } from './AudioManager';

type CostMap = Partial<Currency>;

export const EconomyEngine = {
  grant(amount: CostMap): void {
    const c = GameState.data.currency;
    if (amount.coins) c.coins += amount.coins;
    if (amount.stars) c.stars += amount.stars;
    if (amount.gems) c.gems += amount.gems;
    GameState.persist();
    EventBus.emit('currency-changed', c);
    AudioManager.playSfx('star');
  },

  canAfford(cost: CostMap): boolean {
    const c = GameState.data.currency;
    return (cost.coins ?? 0) <= c.coins
      && (cost.stars ?? 0) <= c.stars
      && (cost.gems ?? 0) <= c.gems;
  },

  spend(cost: CostMap): boolean {
    if (!this.canAfford(cost)) return false;
    const c = GameState.data.currency;
    if (cost.coins) c.coins -= cost.coins;
    if (cost.stars) c.stars -= cost.stars;
    if (cost.gems) c.gems -= cost.gems;
    GameState.persist();
    EventBus.emit('currency-changed', c);
    return true;
  },

  purchaseOutfit(outfitId: string): boolean {
    const outfit = OUTFITS_BY_ID[outfitId];
    if (!outfit || !outfit.cost) return false;
    if (GameState.data.ownedOutfits.some(o => o.outfitId === outfitId)) return false;
    if (!this.spend(outfit.cost)) return false;
    GameState.data.ownedOutfits.push({ outfitId, acquiredAt: Date.now() });
    GameState.persist();
    EventBus.emit('outfit-acquired', outfitId);

    // Milestone check: every 10 outfits
    const total = GameState.data.ownedOutfits.length;
    if (total % 10 === 0) {
      EventBus.emit('toast', { message: `🎉 의상 ${total}개 달성! 보너스 ⭐10`, kind: 'gold' });
      this.grant({ stars: 10 });
    }

    return true;
  },
};
